const NAME = "MY_APPROVED_CONSENTS";

export default NAME;
